<template>
  <Card>
    <h3>Number of facts by Disaster</h3>
    <p>
      This table shows all the disaster facts with GRID tag that are not
      associated to an event.
    </p>
    <ag-grid-vue
      style="width: 100%; height: 420px;"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :rowData="tableData"
    ></ag-grid-vue>
  </Card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";

export default {
  components: { AgGridVue },
  data() {
    return {
      tableData: [],
      gridOptions: {
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        enableRangeSelection: true,
        allowContextMenuWithControlKey: true,
        onGridReady: params => {
          params.api.sizeColumnsToFit();
        },
        getContextMenuItems: params => [
          {
            name: "Go to Fact",
            action: () => {
              const id = params.node.data.fact_id;
              if (id) {
                this.$router.push(`/facts/${id}`);
              }
            },
          },
          "separator",
          ...params.defaultItems,
        ],
      },
      columnDefs: Object.freeze([
        {
          headerName: "Country",
          field: "country",
          enableRowGroup: true,
        },
        {
          headerName: "Event",
          field: "event_name",
          enableRowGroup: true,
        },
        {
          headerName: "Start Date",
          width: 40,
          field: "start_date",
          valueFormatter: value => {
            return moment(value).format("YYYY-MM-DD");
          },
          sortable: true,
        },
      ]),
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let response = await axios.get(
        "/psql/qa_dashboard_grid_fact_by_disaster"
      );
      this.tableData = response.data;
    },
  },
};
</script>
